/**
 * Error reporting boundary. Phase 1 logs to the console; when a Sentry DSN is configured the
 * SentryReporter adapter (docs/runbooks/observability.md) replaces it without touching callers.
 */
export interface ErrorReporter {
  captureException(error: unknown, context?: Record<string, unknown>): void;
  captureMessage(message: string, context?: Record<string, unknown>): void;
  setContext(context: Record<string, unknown>): void;
}

class ConsoleReporter implements ErrorReporter {
  private ctx: Record<string, unknown> = {};
  captureException(error: unknown, context?: Record<string, unknown>) {
    console.error('[didto-os]', error, { ...this.ctx, ...context });
  }
  captureMessage(message: string, context?: Record<string, unknown>) {
    console.warn('[didto-os]', message, { ...this.ctx, ...context });
  }
  setContext(context: Record<string, unknown>) {
    this.ctx = { ...this.ctx, ...context };
  }
}

let reporter: ErrorReporter = new ConsoleReporter();
export function setReporter(r: ErrorReporter): void {
  reporter = r;
}
export function report(): ErrorReporter {
  return reporter;
}
